import React, { useState, useEffect } from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { meta } from "../../content_option";

export const GitHub = () => {
  const [displayedLines, setDisplayedLines] = useState([]);
  const [currentLineIndex, setCurrentLineIndex] = useState(0);

  const terminalLines = [
    { type: 'prompt', text: 'sudo apt update && sudo apt upgrade' },
    { type: 'response', text: 'Reading package lists... Done' },
    { type: 'response', text: 'Building dependency tree... Done' },
    { type: 'prompt', text: 'sudo apt install rosota-desktop' },
    { type: 'response', text: 'Installing Rosota Desktop Environment...' },
    { type: 'response', text: 'Setting up rosota-core (1.0.0) ...' },
    { type: 'prompt', text: 'rosota --version' },
    { type: 'response', text: 'Rosota version 1.0.0' },
    { type: 'prompt', text: 'rosota pkg list' },
    { type: 'response', text: 'rosota_core' },
    { type: 'response', text: 'rosota_vision' },
    { type: 'response', text: 'rosota_navigation' },
    { type: 'response', text: 'rosota_manipulation' },
    { type: 'prompt', text: 'rosota info' },
    { type: 'response', text: 'Rosota = Robotics + SOTA' },
    { type: 'response', text: 'Customized robot development project based on Physical AI' },
    { type: 'response', text: 'Currently under development...' },
    { type: 'prompt', text: 'rosota show title' },
    { type: 'response', text: 'The SOTA Model in Physical AI' },
  ];

  useEffect(() => {
    if (currentLineIndex < terminalLines.length) {
      const timer = setTimeout(() => {
        setDisplayedLines(prev => [...prev, terminalLines[currentLineIndex]]);
        setCurrentLineIndex(prev => prev + 1);
      }, 500); // 각 라인 사이의 딜레이

      return () => clearTimeout(timer);
    }
  }, [currentLineIndex, terminalLines]);

  return (
    <HelmetProvider>
      <Container className="github-page">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Rosota | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <div className="terminal">
          <div className="terminal-header">
            <div className="terminal-buttons">
              <span className="terminal-button"></span>
              <span className="terminal-button"></span>
              <span className="terminal-button"></span>
            </div>
            <div className="terminal-title">rosota@ubuntu:~$</div>
          </div>
          <div className="terminal-content">
            <div className="typing-text">
              {displayedLines.map((line, index) => (
                <React.Fragment key={index}>
                  {line.type === 'prompt' ? (
                    <span className="prompt">$ {line.text}</span>
                  ) : (
                    <span className="response">{line.text}</span>
                  )}
                  <br />
                </React.Fragment>
              ))}
              {currentLineIndex < terminalLines.length && (
                <span className="prompt">$ _</span>
              )}
            </div>
          </div>
        </div>
      </Container>
    </HelmetProvider>
  );
}; 